import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import { CONTAINER_TYPES } from '@src/quince-site-common/src/organisms/pageBuilder'
import { IContainerConfig } from '@src/quince-site-common/src/organisms/pageBuilder/pageBuilder.domains'

import { ProductSectionType } from '../../types/productPage.types'
import {
  DESKTOP_DISCLAIMER,
  DESKTOP_FAQ,
  DESKTOP_FBT,
  DESKTOP_INFLUENCER,
  DESKTOP_PRODUCT_IMAGES_AND_PURCHASE,
  DESKTOP_PRODUCT_REVIEWS,
  DESKTOP_SIMILAR_PRODUCTS,
  DESKTOP_YOU_MAY_ALSO_LIKE,
} from '../common'
import {
  MOBILE_DISCLAIMER,
  MOBILE_FREQUENTLY_BOUGHT_TOGETHER,
  MOBILE_INFORMATION_BOXES,
  MOBILE_PAIR_WITH,
  MOBILE_PRODUCT_IMAGES,
  MOBILE_PRODUCT_PURCHASE,
  MOBILE_PRODUCT_REVIEWS,
  MOBILE_REVIEW_HIGHLIGHTS,
  MOBILE_SIMILAR_PRODUCTS,
  MOBILE_YOU_MAY_ALSO_LIKE,
} from '../common/mobile'

export const giftCardDesktopConfig: IContainerConfig = {
  id: 'DESKTOP_GIFT_CARD_MOBILE_CONFIG_ROOT',
  containerType: CONTAINER_TYPES.ROW,
  children: [
    DESKTOP_PRODUCT_IMAGES_AND_PURCHASE,
    DESKTOP_SIMILAR_PRODUCTS,
    DESKTOP_FBT,
    DESKTOP_INFLUENCER,
    DESKTOP_FAQ,
    DESKTOP_YOU_MAY_ALSO_LIKE,
    DESKTOP_PRODUCT_REVIEWS,
    DESKTOP_DISCLAIMER,
  ],
}

export const giftCardMobileConfig: IContainerConfig = {
  id: 'MOBILE_GIFT_CARD_MOBILE_CONFIG_ROOT',
  containerType: CONTAINER_TYPES.ROW,
  children: [
    MOBILE_PRODUCT_IMAGES,
    MOBILE_PRODUCT_PURCHASE,
    MOBILE_REVIEW_HIGHLIGHTS,
    MOBILE_PAIR_WITH,
    MOBILE_SIMILAR_PRODUCTS,
    {
      id: 'MOBILE_CUSTOM_SECTION_INFLUENCER',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.CUSTOM_SECTION,
        customSectionType: CUSTOM_SECTION_TYPE.INFLUENCER,
      },
    },
    MOBILE_INFORMATION_BOXES,
    MOBILE_FREQUENTLY_BOUGHT_TOGETHER,
    MOBILE_PRODUCT_REVIEWS,
    MOBILE_YOU_MAY_ALSO_LIKE,
    MOBILE_DISCLAIMER,
  ],
}
